// extracted by mini-css-extract-plugin
export default {"header":"TableScrollArea_header__PmMN4","scrolled":"TableScrollArea_scrolled__epc2Z"};